import React from 'react'
import { withPrefix } from 'gatsby'
import * as styles from './styles.module.scss'

/**
 */
const TopBanner = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${withPrefix(
          '/images/layout/icon_top_banner.png',
        )})`,
      }}
      className={styles.TopBanner}
    />
  )
}

/**
 */
export const Content = () => {
  return <TopBanner />
}
